import type { EntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';

const resolveGetKPFByToken =
  <T = EntityData<KPF>>(token: string) =>
  async (gqlFields: BaseQLSelectionSet<KPF>) => {
    const col = await getRawCollection<EntityData<KPF>>(KPF._collectionName);
    const kpf = await col.findOne({
      $or: [{ accessTokenForStudents: token }, { accessTokenForExternals: token }],
    });
    if (!kpf) throw new Error('Token not found');
    if (kpf.accessTokenForStudents === token && !kpf.tokenAccessEnabled) throw new Error('Token is expired');
    if (kpf.accessTokenForExternals === token && !kpf.accessTokenForExternals) throw new Error('Token is expired');
    return kpf;
  };

const getKPFbyToken = registerQuery({
  type: () => KPF,
  operationName: 'getKPFbyToken',
  params: [{ type: () => String, name: 'token' }],
  resolve: resolveGetKPFByToken<KPF>,
});

export namespace KPFSecureAccessAPI {
  export const getByToken = getKPFbyToken;
}
